export default "__VITE_ASSET__S21mttis__"